import {Component} from 'react';
import h from 'react-hyperscript';
import './ClassroomActivity.scss';
import BasicCard from 'Components/Cards/BasicCard';
import {h4, caption} from 'Components/Typography/Typography';
import Image from 'Components/Image/Image';
import ClassroomDisabled from './ClassroomDisabled';
import MobileMenu from 'Components/MobileMenu/MobileMenu';
import ClassroomActivityTabContent from './TabContent';
import TabHeader from 'Components/TabHeader/TabHeader';
import {getSum, setZeroIfInvalidNumber, isArrayEmpty} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';

class ClassroomActivity extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      activeTab: 0,
      mobileAnchorEl: null,
      isClassroomDisabled: false,
      activeTeachers: 0,
      activeStudents: 0,
      teacherPostsCreated: 0,
      studentPostsCreated: 0,
      hasError: false,
    };

    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.changeContent = this.handleTabClick.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  setData() {
    if (this.dataAvailable) {
      this.setClassroomData();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return (
      this.props.hasProductMetricsHistory &&
      !isArrayEmpty(this.props.data) &&
      !isArrayEmpty(this.props.tabs)
    );
  }

  setHasError(value) {
    this.setState({
      hasError: value,
    });
  }

  setClassroomData() {
    if (this._isMounted) {
      const activeStudents = this.getAverageWeeklyNumbers('students');
      const numStudents = this.props.numStudents;
      const percentageStudents = Math.round(
          (activeStudents / numStudents) * 100
      );

      const activeTeachers = this.getAverageWeeklyNumbers('teachers');
      const numTeachers = this.props.numTeachers;
      const percentageTeachers = Math.round(
          (activeTeachers / numTeachers) * 100
      );

      if (activeStudents < 1 && activeTeachers < 1) {
        this.setClassroomDisabled(true);
      } else {
        this.setClassroomDisabled(false);
        this.setActiveStudents(setZeroIfInvalidNumber(activeStudents));
        this.setActiveTeachers(setZeroIfInvalidNumber(activeTeachers));
        this.setPercentageStudents(setZeroIfInvalidNumber(percentageStudents));
        this.setPercentageTeachers(setZeroIfInvalidNumber(percentageTeachers));
      }
    }
  }

  getAverageWeeklyNumbers(type) {
    const denominator = 12;
    const weeklyData = this.props.data.map((week) => {
      const apiId = `classroom_${type}`;
      return week[apiId];
    });
    const activeUsers = getSum(weeklyData);
    if (activeUsers < 1 || !activeUsers) {
      return 0;
    }
    return activeUsers / denominator;
  }

  handleTabClick(e) {
    e.preventDefault();
    this.setActiveTab(e.currentTarget.getAttribute('datatab'));
  }

  setActiveTab(value) {
    this.setState({
      activeTab: value,
    });
  }

  handleMobileMenuOpen(e) {
    this.setState({
      mobileAnchorEl: e.currentTarget,
    });
  }

  handleMobileMenuClose() {
    this.setState({
      mobileAnchorEl: null,
    });
  }

  setClassroomDisabled(value) {
    this.setState({
      isClassroomDisabled: value,
    });
  }

  setActiveTeachers(value) {
    this.setState({
      activeTeachers: value,
    });
  }

  setActiveStudents(value) {
    this.setState({
      activeStudents: value,
    });
  }

  setPercentageStudents(value) {
    this.setState({
      percentageStudents: value,
    });
  }

  setPercentageTeachers(value) {
    this.setState({
      percentageTeachers: value,
    });
  }

  createElements() {
    if (this.state.isClassroomDisabled) {
      return h(
          ClassroomDisabled,
          {
            content: this.props.disabledContent,
          },
          null
      );
    } else {
      return [
        h(
            MobileMenu,
            {
              key: 'four-cs--mobile__menu',
              id: 'four-cs--mobile__menu',
              selectedIndex: this.state.activeTab,
              anchorEl: this.state.mobileAnchorEl,
              menuList: this.props.tabs,
              handleMobileMenuOpen: this.handleMobileMenuOpen,
              handleMobileMenuClose: this.handleMobileMenuClose,
              changeContent: this.handleTabClick,
            },
            null
        ),

        h(
            'div',
            {
              key: 'classroom-activity-tabs',
              className: 'flex--space-between tab__titles hide--mobile',
            },
            this.props.tabs.map((tab, i) => {
              return h(
                  TabHeader,
                  {
                    i: i,
                    inactiveClasses: 'tab__title padding-bottom--micro',
                    handleTabClick: this.changeContent,
                    activeTab: this.state.activeTab,
                  },
                  h(caption, null, tab.title)
              );
            })
        ),

        h(
            'div',
            {
              key: `tab-content`,
              className: 'padding-top--sm',
            },
            this.props.tabs.map((tab, i) => {
              const percentageStudents = this.state.percentageStudents || 0;
              const percentageTeachers = this.state.percentageTeachers || 0;
              return h(
                  ClassroomActivityTabContent,
                  {
                    i: i,
                    id: tab.title.toLowerCase(),
                    tab: tab,
                    activeTab: this.state.activeTab,
                    activeStudents: Math.round(this.state.activeStudents),
                    activeTeachers: Math.round(this.state.activeTeachers),
                    percentageStudents: `${percentageStudents}%`,
                    percentageTeachers: `${percentageTeachers || 0}%`,
                    isClassroomDisabled: this.state.isClassroomDisabled,
                  },
                  null
              );
            })
        ),
      ];
    }
  }

  render() {
    return h(
        BasicCard,
        {
          id: this.props.id,
          className: this.props.className,
        },
        [
          h(
              h4,
              {
                key: 'classroom-activity-title',
                className: 'card__title flex',
              },
              [
                h(
                    Image,
                    {
                      key: 'classroom-activity-image',
                      src: this.props.icon,
                      className: 'padding-right--micro accordion__header__icon',
                      srcSet: {
                        standard: this.props.icon,
                        retina: this.props.icon_2x,
                      },
                    },
                    null
                ),
                this.props.title,
              ]
          ),
        this.state.hasError ?
          h(
              ReportError,
              {
                message: this.props.noDataError,
              },
              null
          ) :
          this.createElements(),
        ]
    );
  }
}

export default ClassroomActivity;
